import { Box, Button } from '@mui/material';
import { Icon } from '@iconify/react';

const DeleteButton = ({ action, size, children, disabled, sx }) => {
  return (
    <Button
      sx={{ ...sx, backgroundColor: '#ffe4de', color: '#c03530' }}
      onClick={action}
      autoFocus={false}
      disabled={disabled}
      size={size}
    >
      <Icon icon="material-symbols:delete-outline-rounded" width="25" height="25" />
      {children}
    </Button>
  );
};

const CancelButton = ({ action, size, children, component, to, disabled }) => {
  return (
    <Button
      size={size}
      component={component}
      to={to}
      sx={{ backgroundColor: '#bbd1e4cf', color: '#3173b4' }}
      onClick={action}
      disabled={disabled}
    >
      <Icon icon="radix-icons:cross-2" width="22" height="22" /> {children}
    </Button>
  );
};

const SaveButton = ({ action, type, size, children, disabled }) => {
  return (
    <Button
      size={size}
      disabled={disabled}
      sx={{
        marginLeft: 2,
        backgroundColor: '#c8facd',
        color: '#0db05d',
      }}
      onClick={action}
      type={type}
    >
      <Icon icon="mdi:content-save-check-outline" width="25" height="25" />

      {children}
    </Button>
  );
};

const ResetButton = ({ action, size, type, disabled, children }) => {
  return (
    <Button
      type={type}
      size={size}
      sx={{ backgroundColor: '#eff4f9', color: '#3173b4' }}
      onClick={action}
      disabled={disabled}
    >
      {children}
    </Button>
  );
};

const SendButton = ({ type, size, action, disabled, children, variant }) => {
  return (
    <Button
      variant={variant}
      type={type}
      size={size}
      sx={{
        backgroundColor: '#7e4d8b36',
        color: '#7e4d8b',
        boxShadow: 5,
        margin: 0.5,
      }}
      onClick={action}
      disabled={disabled}
    >
      {children}
      <Icon icon="material-symbols:send-outline-rounded" width="20" height="20" />
    </Button>
  );
};

const NextButton = ({ action, disabled, children, type, size, variant }) => {
  return (
    <Button
      variant={variant}
      type={type}
      size={size}
      sx={{
        ':hover': {
          bgcolor: '#ffffff',
          color: '#2f72b3',
        },
        backgroundColor: '#2f72b3',
        color: '#ffffff',
        boxShadow: 5,
        margin: 0.5,
        boxShadow: 5,
      }}
      onClick={action}
      disabled={disabled}
    >
      {children}
      <Icon icon="tabler:player-track-next" width="25" height="25" />
    </Button>
  );
};

const SubmitButton = ({ action, disabled, children, type, size, variant, value, component, to, sx }) => {
  return (
    <Button
      variant={variant}
      type={type}
      size={size}
      onClick={action}
      value={value}
      component={component}
      to={to}
      disabled={disabled}
      sx={{ sx, backgroundColor: '#7e4d8b6e', color: '#7e4d8b' }}
    >
      <Icon icon="grommet-icons:status-good" width="25" height="25" />
      {children}
    </Button>
  );
};

const EditButton = ({ action, disabled, children, type, size, variant, value, component, to, sx }) => {
  return (
    <Button
      variant={variant}
      type={type}
      size={size}
      onClick={action}
      value={value}
      component={component}
      disabled={disabled}
      to={to}
      sx={{ ...sx, backgroundColor: '#7e4d8b6e', color: '#7e4d8b' }}
    >
      <Icon icon="material-symbols:edit-note" width="25" height="25" />
      {children}
    </Button>
  );
};

const UpdateButton = ({ action, type, size, children, disabled }) => {
  return (
    <Button
      disabled={disabled}
      size={size}
      sx={{
        marginLeft: 2,
        backgroundColor: '#c8facd',
        color: '#0db05d',
      }}
      onClick={action}
      type={type}
    >
      <Icon icon="radix-icons:update" width="25" height="25" />

      {children}
    </Button>
  );
};

const UpdateIcon = ({ action, type, size, children, disabled }) => {
  return (
    <Button
      disabled={disabled}
      size={size}
      sx={{
        marginLeft: 2,
        backgroundColor: '#677DB7',
        color: '#fff',
      }}
      onClick={action}
      type={type}
    >
      <Icon icon="akar-icons:edit" width="25" height="25" />

      {children}
    </Button>
  );
};

const AddButton = ({ action, size, children, component, to, disabled, variant, sx, type }) => {
  return (
    <Button
      variant={variant}
      size={size}
      component={component}
      to={to}
      sx={{ backgroundColor: '#eff4f9', color: '#3173b4', ...sx }}
      onClick={action}
      disabled={disabled}
      type={type}
    >
      <Icon icon="mingcute:add-line" width="20" height="20" />

      {children}
    </Button>
  );
};

const LogButton = ({ action, disabled, children, type, size, variant, value, sx }) => {
  return (
    <Button
      variant={variant}
      type={type}
      size={size}
      onClick={action}
      value={value}
      disabled={disabled}
      sx={{ sx, backgroundColor: '#7e4d8b6e', color: '#7e4d8b' }}
    >
      <Icon icon="gg:details-more" width="22" height="22" />

      {children}
    </Button>
  );
};

const SearchButton = ({ action, disabled, children, type, size, variant, value, sx }) => {
  return (
    <Button
      variant={variant}
      type={type}
      size={size}
      onClick={action}
      value={value}
      disabled={disabled}
      sx={{ sx, backgroundColor: '#7e4d8b6e', color: '#7e4d8b' }}
    >
      <Icon icon="mdi:file-search-outline" width="25" height="25" />

      {children}
    </Button>
  );
};

const ApproveButton = ({ action, type, size, children, disabled }) => {
  return (
    <Button
      disabled={disabled}
      size={size}
      sx={{
        marginLeft: 2,
        backgroundColor: '#c8facd',
        color: '#0db05d',
      }}
      onClick={action}
      type={type}
    >
      <Icon icon="mdi:approve" width="20" height="20" />
      {children}
    </Button>
  );
};
const RejectButton = ({ action, size, children, disabled, sx, type }) => {
  return (
    <Button
      sx={{ ...sx, backgroundColor: '#ffe4de', color: '#c03530' }}
      onClick={action}
      autoFocus={false}
      disabled={disabled}
      size={size}
      type={type}
    >
      <Icon icon="radix-icons:cross-2" />
      {children}
    </Button>
  );
};

const LogOutButton = ({ action, size, children, disabled, sx, type }) => {
  return (
    <Button
      sx={{ ...sx, backgroundColor: '#ffe4de', color: '#c03530' }}
      onClick={action}
      autoFocus={false}
      disabled={disabled}
      size={size}
      type={type}
    >
      <Icon icon="bx:log-out" width="20" height="20" />
      {children}
    </Button>
  );
};

const ActiveButton = ({ action, size, children, disabled, sx, type }) => {
  return (
    <Button
      sx={{ ...sx, backgroundColor: '#c8facd', color: '#0db05d' }}
      onClick={action}
      autoFocus={false}
      disabled={disabled}
      size={size}
      type={type}
    >
      <Icon
        width="30"
        height="30"
        style={{
          marginRight: '2px',
        }}
        icon="openmoji:toggle-button-state-b"
      />
      {children}
    </Button>
  );
};

const InactiveButton = ({ action, size, children, disabled, sx, type }) => {
  return (
    <Button
      sx={{ ...sx, backgroundColor: '#ffe4de', color: '#c03530' }}
      onClick={action}
      autoFocus={false}
      disabled={disabled}
      size={size}
      type={type}
    >
      <Icon
        width="30"
        height="30"
        style={{
          marginRight: '2px',
        }}
        icon="openmoji:toggle-button"
      />
      {children}
    </Button>
  );
};

const ViewButton = ({ action, size, children, disabled, sx, type, variant }) => {
  return (
    <Button
      sx={{ ...sx, backgroundColor: '#eff4f9', color: '#3173b4' }}
      onClick={action}
      autoFocus={false}
      disabled={disabled}
      size={size}
      type={type}
      variant={variant}
    >
      <Icon
        width="20"
        height="20"
        style={{
          marginRight: '2px',
        }}
        icon="ep:view"
      />
      {children}
    </Button>
  );
};

const BulkApprove = ({ action, type, size, children, disabled }) => {
  return (
    <Button
      disabled={disabled}
      size={size}
      sx={{
        backgroundColor: '#c8facd',
        color: '#0db05d',
      }}
      onClick={action}
      type={type}
    >
      <Icon icon="icomoon-free:stack" style={{ marginRight: '5px' }} width="25" height="25" />

      {children}
    </Button>
  );
};

const Navigate = ({ rotate, btnName, action }) => {
  return (
    <Box>
      <Button
        onClick={action}
        size="small"
        variant="outlined"
        sx={{
          minWidth: '100px',
          background: 'linear-gradient(45deg, #a125c2, #0089d0)',
          color: '#ffffff',
          fontWeight: 'bold',
          overflow: 'hidden',
          borderRadius: '8px',
          transition: '0.3s',
          position: 'relative',
          '&:hover': {
            background: 'linear-gradient(45deg, #0089d0, #a125c2)',
          },
        }}
      >
        <Box>
          <span className="flip-effect">{rotate}</span>
          <span style={{ paddingRight: '4px' }}>{btnName}</span>
        </Box>
      </Button>

      <style>
        {`
          @keyframes flipX {
            0% { transform: scaleX(1); }   /* Normal */
            50% { transform: scaleX(-1); } /* Flipped horizontally */
            100% { transform: scaleX(1); } /* Back to normal */
          }

          .flip-effect {
            display: inline-block;
            animation: flipX 1.5s infinite ease-in-out;
          }
        `}
      </style>
    </Box>
  );
};

const UpdateButtonNew = ({
  sx = {},
  onClick,
  type = 'button',
  size = 'small',
  variant = 'outlined',
  disabled = false,
  children = 'Update',
  startIcon,
  endIcon,
  color,
}) => {
  const defaultStartIcon = <Icon icon="clarity:update-line" width="20" height="20" />;
  const defaultWarningColor = {
    backgroundColor: '#ED6C02',
    color: '#fff',
    '&:hover': {
      backgroundColor: '#E65100',
    },
  };

  return (
    <Button
      color={color}
      variant={variant}
      size={size}
      disabled={disabled}
      startIcon={startIcon || defaultStartIcon}
      endIcon={endIcon}
      onClick={onClick}
      type={type}
      sx={{
        boxShadow: 'none',
        px: 2,
        // ...(color ? {} : defaultWarningColor),
        ...sx,
      }}
    >
      {children}
    </Button>
  );
};

const ViewButtonNew = ({
  sx = {},
  onClick,
  type = 'button',
  size = 'small',
  variant = 'outlined',
  disabled = false,
  children = 'View',
  startIcon,
  endIcon,
  color,
}) => {
  const defaultStartIcon = <Icon icon="carbon:view-filled" width="20" height="20" />;
  return (
    <Button
      color={color}
      variant={variant}
      size={size}
      disabled={disabled}
      startIcon={startIcon || defaultStartIcon}
      endIcon={endIcon}
      onClick={onClick}
      type={type}
      sx={{
        boxShadow: 'none',
        px: 2,
        ...sx,
      }}
    >
      {children}
    </Button>
  );
};

const ActionButtonNew = ({
  sx = {},
  onClick,
  type = 'button',
  size = 'small',
  variant = 'outlined',
  disabled = false,
  children = 'Action',
  startIcon,
  endIcon,
  color,
}) => {
  return (
    <Button
      color={color}
      variant={variant}
      size={size}
      disabled={disabled}
      startIcon={startIcon}
      endIcon={endIcon}
      onClick={onClick}
      type={type}
      sx={{
        boxShadow: 'none',
        px: 2,
        ...sx,
      }}
    >
      {children}
    </Button>
  );
};

const DeleteButtonNew = ({
  sx = {},
  onClick,
  type = 'button',
  size = 'small',
  variant = 'outlined',
  disabled = false,
  children = 'Delete',
  startIcon,
  endIcon,
  color = 'error',
}) => {
  const defaultStartIcon = <Icon icon="material-symbols:delete-outline-rounded" width="20" height="20" />;
  return (
    <Button
      color={color}
      variant={variant}
      size={size}
      disabled={disabled}
      startIcon={startIcon || defaultStartIcon}
      endIcon={endIcon}
      onClick={onClick}
      type={type}
      sx={{
        boxShadow: 'none',
        px: 2,
        ...sx,
      }}
    >
      {children}
    </Button>
  );
};

export {
  DeleteButton,
  CancelButton,
  SaveButton,
  ResetButton,
  SendButton,
  NextButton,
  SubmitButton,
  EditButton,
  UpdateButton,
  UpdateIcon,
  AddButton,
  LogButton,
  SearchButton,
  ApproveButton,
  RejectButton,
  LogOutButton,
  ActiveButton,
  InactiveButton,
  ViewButton,
  BulkApprove,
  Navigate,
  UpdateButtonNew,
  ViewButtonNew,
  ActionButtonNew,
  DeleteButtonNew,
};
